import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
// Reducers
import authReducer from "../slices/authSlice";
import enumReducer from "../slices/enumSlice";
import userReducer from "../slices/enumSlice";
import emailSliceReducer from "../slices/emailSlice";
import blogsSliceReducer from "../slices/blogsSlice";
import navReducer from "../slices/navSlice";
import parkingReducer from "../slices/parkingSlice";
import HomeReducer from "../slices/HomeSlice";
import favouriteReducer from "../slices/favouriteSlice";
import ParkingTypeReducer from "../slices/parkingTypeSlice";
import cartReducer from "../slices/cartSlice";
import serviceProviderFeedbackReducer from "../slices/serviceProviderFeedbackSlice";
import RLRestSlice from "../slices/RLRestSlice";
import customerReducer from "../slices/customerSlice";
import OfferReducer from "../slices/offerSlice";
import invoiceSliceReducer from "../slices/invoiceSlice";
import bookingReducer from "../slices/bookingSlice";
import stripeSliceReducer from "../slices/stripeSlice";
import vehicleReducer from '../slices/vehicleSlice';
import paymentReducer from '../slices/parkingSlice';
import cashFreeReducer from '../slices/cashFreeSlice';
import cityReducer from '../slices/citySlice';
import feedbackReducer from '../slices/feedbackSlice';

// Services
import { enumApi } from "../services/enumApi";
import { emailApi } from "../services/emailApi";
import { blogsApi } from "../services/blogsApi";
import { contactSupportApi } from "../services/contactSupportApi";
import { serviceProviderApi } from "../services/serviceProviderApi";
import { generateQrCodeApi } from "../services/generateQrCodeApi";
import { bookingApi } from "../services/bookingApi";
import { authApi } from "../services/authApi";
import { parkingsApi } from "../services/parkingsApi";
import { HomeApi } from "../services/HomeApi";
import { favouriteApi } from "../services/favouriteApi";
import { parkingTypeApi } from "../services/parkingTypeApi";
import { cartApi } from "../services/cartApi";
import { serviceProviderFeedbackApi } from "../services/serviceProviderFeedbackApi";
import { RLRestApi } from "../services/RLRestApi";
import { customerApi } from "../services/customerService";
import { userApi } from "../services/userApi";
import { contactUsApi } from "../services/contactUsApi";
import { offerApi } from "../services/offerApi";
import { customerBalanceApi } from "../services/customerBalanceApi";
import { invoiceApi } from "../services/invoiceApi";
import { qrCodePdfDownloadAPI } from "../services/qrCodePdfDownloadApi";
import { downloadInvoiceAPI } from "../services/downloadInvoiceApi";
import { calculateBillingRateApi } from "../services/calculateBillingRateService";
import { stripeApi } from "../services/stripeApi";
import { vehicleApi } from '../services/VehicleApi';
import { paymentApi } from "../services/paymentApi";
import { cityApi } from "../services/cityApi";
import { feedbackApi } from "../services/feedbackApi";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    favourite: favouriteReducer,
    parkingTye: ParkingTypeReducer,
    serviceProviderFeedback: serviceProviderFeedbackReducer,
    RLRest: RLRestSlice,
    feedback: feedbackReducer,
    customer: customerReducer,
    parkings: parkingReducer,
    home: HomeReducer,
    offer: OfferReducer,
    invoice: invoiceSliceReducer,
    bookings: bookingReducer,
    stripePayment: stripeSliceReducer,
    nav: navReducer,
    enum: enumReducer,
    user: userReducer,
    email: emailSliceReducer,
    blogs: blogsSliceReducer,
    cart: cartReducer,
    vehicle:vehicleReducer,
    payment :paymentReducer,
    cashFree: cashFreeReducer,
    city: cityReducer,
    [authApi.reducerPath]: authApi.reducer,
    [feedbackApi.reducerPath]: feedbackApi.reducer,
    [parkingsApi.reducerPath]: parkingsApi.reducer,
    [HomeApi.reducerPath]: HomeApi.reducer,
    [favouriteApi.reducerPath]: favouriteApi.reducer,
    [parkingTypeApi.reducerPath]: parkingTypeApi.reducer,
    [cartApi.reducerPath]: cartApi.reducer,
    [serviceProviderFeedbackApi.reducerPath]:
    serviceProviderFeedbackApi.reducer,
    [RLRestApi.reducerPath]: RLRestApi.reducer,
    [customerApi.reducerPath]: customerApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [contactUsApi.reducerPath]: contactUsApi.reducer,
    [offerApi.reducerPath]: offerApi.reducer,
    [customerBalanceApi.reducerPath]: customerBalanceApi.reducer,
    [invoiceApi.reducerPath]: invoiceApi.reducer,
    [qrCodePdfDownloadAPI.reducerPath]: qrCodePdfDownloadAPI.reducer,
    [downloadInvoiceAPI.reducerPath]: downloadInvoiceAPI.reducer,
    [calculateBillingRateApi.reducerPath]: calculateBillingRateApi.reducer,
    [stripeApi.reducerPath]: stripeApi.reducer,
    [enumApi.reducerPath]: enumApi.reducer,
    [emailApi.reducerPath]: emailApi.reducer,
    [blogsApi.reducerPath]: blogsApi.reducer,
    [contactSupportApi.reducerPath]: contactSupportApi.reducer,
    [serviceProviderApi.reducerPath]: serviceProviderApi.reducer,
    [generateQrCodeApi.reducerPath]: generateQrCodeApi.reducer,
    [bookingApi.reducerPath]: bookingApi.reducer,
    [vehicleApi.reducerPath]:vehicleApi.reducer,
    [paymentApi.reducerPath]:paymentApi.reducer,
    [cityApi.reducerPath]: cityApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(authApi.middleware)
      .concat(HomeApi.middleware)
      .concat(parkingsApi.middleware)
      .concat(favouriteApi.middleware)
      .concat(parkingTypeApi.middleware)
      .concat(cartApi.middleware)
      .concat(serviceProviderFeedbackApi.middleware)
      .concat(customerApi.middleware)
      .concat(userApi.middleware)
      .concat(contactUsApi.middleware)
      .concat(offerApi.middleware)
      .concat(customerBalanceApi.middleware)
      .concat(invoiceApi.middleware)
      .concat(qrCodePdfDownloadAPI.middleware)
      .concat(downloadInvoiceAPI.middleware)
      .concat(calculateBillingRateApi.middleware)
      .concat(enumApi.middleware)
      .concat(stripeApi.middleware)
      .concat(emailApi.middleware)
      .concat(blogsApi.middleware)
      .concat(contactSupportApi.middleware)
      .concat(serviceProviderApi.middleware)
      .concat(generateQrCodeApi.middleware)
      .concat(bookingApi.middleware)
      .concat(vehicleApi.middleware)
      .concat(paymentApi.middleware)
      .concat(cityApi.middleware)
      .concat(feedbackApi.middleware)
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
